import { Tick, TickRange } from '@common/valueSeries';
import {
    MarginParams,
    ScaleNumeric,
    ScaleTickRange,
    ScaleTickRangeInput,
    TooltipInfo,
    useTickRangeTooltipInfo,
    useXScaleForTickRange,
    useYScaleNumeric,
} from './chartHelper';

export const useTickRangeNumericChartWithTooltip = <Data extends Tick>({
    range,
    innerHeight,
    innerWidth,
    yScaleDomain,
    maxValueForDate,
    tooltipDataForDate,
    margin = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
    },
    xScaleType,
    tooltipXBuffer,
    padDomain,
    shouldClampY = true,
}: {
    range: TickRange;
    innerWidth: number;
    innerHeight: number;
    yScaleDomain: (number | null)[];
    maxValueForDate: (date: string) => number;
    tooltipDataForDate: (date: string) => Data | undefined;
    margin: MarginParams;
    xScaleType?: ScaleTickRangeInput['type'];
    tooltipXBuffer?: number;
    padDomain?: number;
    shouldClampY?: boolean;
}): TooltipInfo<Data> & {
    xScale: ScaleTickRange;
    yScale: ScaleNumeric;
} => {
    const xScale = useXScaleForTickRange({
        width: innerWidth,
        range,
        type: xScaleType,
    });

    const yScale = useYScaleNumeric({
        domain: yScaleDomain,
        height: innerHeight,
        padDomain,
        shouldClamp: shouldClampY,
    });

    const tooltipInfo = useTickRangeTooltipInfo({
        xScale,
        yScale,
        maxValueForDate,
        tooltipDataForDate,
        innerWidth,
        margin,
        xBuffer: tooltipXBuffer,
    });

    return {
        xScale,
        yScale,
        ...tooltipInfo,
    };
};
